import React from 'react';
import { useExpanded } from '../hooks/use-expanded';
import { getMealCount } from '../utils/meals';
import {
    PRODUCTS_IN_ROW,
    PRODUCTS_IN_ROW_TABLET,
    PRODUCTS_IN_ROW_LAPTOP,
    TABLET_SCREEN_WIDTH,
    LAPTOP_SCREEN_WIDTH,
    TRANSLATIONS_MEALS_REPLACEMENT,
    TRANSLATIONS_CATEGORY_NAME_REPLACEMENT,
    TRANSLATIONS_PRODUCTS_COUNT_REPLACEMENT,
} from '../constants';
import { Product } from './Product';
import { divideArrayIntoChunks } from '../../../../../library/array/array';
import { getTranslationKeyWithInflection } from '../inflexion';
import { DEFAULT_PRODUCT_INCREMENT } from '../../package-calculation/hooks/use-products';

export const ProductCategory = ({
    category,
    products,
    onIncrementProduct,
    onDecrementProduct,
    onProductAmountChange,
    defaultExpanded,
    translations,
    phaseStep,
    hasPhaseStepMealsCompleted,
    remainingProductsToCompleteCount,
    productAvailabilityMap,
}) => {
    const { expanded, toggleExpanded } = useExpanded(phaseStep, defaultExpanded);

    const meals = getMealCount(products);

    const getProductsInRowByScreenWidth = () => {
        const screenWidth = window.innerWidth;

        if (screenWidth < TABLET_SCREEN_WIDTH) {
            return PRODUCTS_IN_ROW_TABLET;
        }
        if (screenWidth < LAPTOP_SCREEN_WIDTH) {
            return PRODUCTS_IN_ROW_LAPTOP;
        }

        return PRODUCTS_IN_ROW;
    };

    const productsInRow = getProductsInRowByScreenWidth();

    const productRows = divideArrayIntoChunks(products, productsInRow);

    const hasSomeProductExceedAvailability =
        products && products.length > 0
            ? products.some((product) =>
                  productAvailabilityMap[product.id] ? productAvailabilityMap[product.id].available < 0 : false
              )
            : false;

    return (
        <div className={`product-category${expanded ? ' expanded' : ''}`}>
            <div className="product-category__header-wrapper">
                {!!category.image && (
                    <div className="product-category__image-wrapper">
                        <img src={`/${category.image}`} alt={category.name} />
                    </div>
                )}
                <div className="product-category__header">
                    <div className="product-category__name-wrapper">
                        <div className="product-category__name" onClick={toggleExpanded}>
                            {`${category.name} (${translations[
                                getTranslationKeyWithInflection(
                                    'eshop.configurator.product_count',
                                    products ? products.length : 0
                                )
                            ]
                                .replace(TRANSLATIONS_CATEGORY_NAME_REPLACEMENT, category.name)
                                .replace(TRANSLATIONS_PRODUCTS_COUNT_REPLACEMENT, products ? products.length : 0)})
                            `}
                        </div>
                        {(meals && (
                            <div
                                className={`picked-amount${
                                    hasSomeProductExceedAvailability ? ' picked-amount--with-error' : ''
                                }`}
                            >
                                {translations['eshop.configurator.message_part.selected'].toLowerCase()}:{' '}
                                {translations[
                                    getTranslationKeyWithInflection(
                                        'eshop.configurator.message_part.portion_count',
                                        meals
                                    )
                                ].replace(TRANSLATIONS_MEALS_REPLACEMENT, meals)}
                            </div>
                        )) ||
                            null}
                    </div>
                    <div className="product-category__expand-icon" onClick={toggleExpanded}>
                        {expanded ? (
                            <img src="../../../../img/theme/icons/14-minus.green.svg" alt="expand" />
                        ) : (
                            <img src="../../../../img/theme/icons/14-plus.green.svg" alt="expand" />
                        )}
                    </div>
                </div>
            </div>
            {expanded && (
                <div className="react-calculator-products-wrapper">
                    {productRows && productRows.length ? (
                        productRows.map((productRow, index) => (
                            <div key={`product-row-${index}`} className="product-row">
                                {productRow.length
                                    ? productRow.map((product) => (
                                          <Product
                                              key={product.id}
                                              id={product.id}
                                              name={product.name}
                                              amount={product.amount}
                                              imageUrl={product.imageUrl}
                                              flags={product.flags}
                                              productUrl={product.productUrl}
                                              onDecrementProduct={() => onDecrementProduct(product)}
                                              onIncrementProduct={() => onIncrementProduct(product)}
                                              onProductAmountChange={onProductAmountChange}
                                              availability={productAvailabilityMap[product.id].available}
                                              tags={product.tags}
                                              hasPhaseStepMealsCompleted={hasPhaseStepMealsCompleted}
                                              remainingProductsToCompleteCount={remainingProductsToCompleteCount}
                                              isIncrementButtonDisabled={
                                                  remainingProductsToCompleteCount <
                                                  (product.increment || DEFAULT_PRODUCT_INCREMENT)
                                              }
                                              disabledIncrementButtonText={
                                                  translations['eshop.configurator.increment_button_disabled_title']
                                              }
                                              productNotAvailableButtonText={
                                                  translations['eshop.configurator.info.product_not_available']
                                              }
                                          />
                                      ))
                                    : null}
                            </div>
                        ))
                    ) : (
                        <div>{translations['eshop.configurator.info.no_product_found']}</div>
                    )}
                </div>
            )}
        </div>
    );
};
